export function subscribePodOs(component) {
    component.subscribePodOs.emit(component.receivePodOs);
}
//# sourceMappingURL=PodOsAware.js.map
